import EditIcon from "@/assets/icons/EditIcon";
import { Heading, Paragraph } from "@/components/ui/Typography";
import { useState } from "react";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import TimelineItemForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TimelineItemForm";
import { TemplateDataSchemaType } from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/templateDataSchema";
import { Trash2Icon } from "lucide-react";
import { sanitizeHtml } from "@/utils/helpers/html";


const TimelineItem = ({data, itemIndex}:{data: TemplateDataSchemaType["missionTimeLineSection"]["missionTimeLineSectionDetails"][0]; itemIndex: number}) => {

  const [isEditing, setIsEditing] = useState(false);
  const { templatePayload:templateData, updateTemplatePayload } = useMicroSiteContext();
    const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
    const [showDeleteIcon, setShowDeleteIcon] = useState(false);

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full  gap-2  justify-center" onMouseEnter={() => setShowDeleteIcon(true)} onMouseLeave={() => setShowDeleteIcon(false)} >   

{/* Delete Icon */}
{showDeleteIcon && isEdit &&  <div className="absolute top-2 right-2 flex items-center justify-center rounded  z-10 cursor-pointer">
  <Trash2Icon color="red" onClick={() => {
    const updatedDetails = templateData.missionTimeLineSection?.missionTimeLineSectionDetails?.filter((_, index) => index !== itemIndex
    ) || [];
    const updatedPayload = {
      ...templateData,
      missionTimeLineSection: {
        ...templateData.missionTimeLineSection,
        missionTimeLineSectionDetails: updatedDetails
      }
    };
    updateTemplatePayload(updatedPayload);
  }} /> 
  </div>}

          <div className="flex items-center gap-3">
            <Paragraph style={{color: templateData.branding.websiteColorCode }} className="uppercase !m-0">{data.missionTimeLineStartDate}-{data.missionTimeLineEndDate}</Paragraph>
          
{isEdit && <EditIcon  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
          <Heading level={3}>{data.missionTimeLineSectionTitle}</Heading>
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.missionTimeLineSectionDescription ?? "") }} ></Paragraph>
          <img src={data.missionTimeLineSectionImageUrl} alt={data.missionTimeLineSectionTitle} className="max-h-64 w-full object-cover object-center rounded" />
      </div>
    )
  };

  return (
    <div>
      {isEditing ? <TimelineItemForm setIsEditing={setIsEditing} timelineData={data} /> : <PreviewComponent />}
    </div>
  )
}

export default TimelineItem